import React, { useState } from 'react';
import { XIcon } from '@primer/octicons-react';
import axios from 'axios';
import { toast } from 'react-toastify';

function Bookmark({ title, url, editMode, bookmarkId }) {
    const [icon404, setIcon404] = useState(false);

    const deleteBookmark = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const path = '/api/deletebookmark';
        const payload = {
            bookmark_id: bookmarkId
        };

        axios.post(path, payload)
            .then((res) => {
                if (res.data.status === 'success') {
                    window.location.reload();
                } else {
                    toast.error(res.data.message, {
                        position: 'top-center',
                        autoClose: 3000
                    });
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const getTouchicon = (url) => {
        if (icon404) {
            return getFavicon(url);
        }

        try {
            const parsed = new URL(url);
            return parsed.origin + "/apple-touch-icon.png";
        } catch (e) {
            return '';
        }
    };

    const getFavicon = (url) => {
        try {
            const parsed = new URL(url);
            return "https://s2.googleusercontent.com/s2/favicons?domain_url=" + parsed.origin;
        } catch (e) {
            return '';
        }
    };

    const handleImageError = () => {
        setIcon404(true);
    };

    const handleClick = (e) => {
        if (editMode) {
            e.preventDefault();
        }
    };

    return (
        <a
            href={editMode ? '#' : url}
            target={editMode ? '' : '_blank'}
            rel="noopener noreferrer"
            onClick={handleClick}
            className="block group"
        >
            <div className="relative bg-white rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 p-6 h-48 flex flex-col items-center justify-center overflow-hidden group-hover:scale-105">
                {/* Favicon */}
                <div className="mb-4">
                    <img
                        src={getTouchicon(url)}
                        alt=""
                        onError={handleImageError}
                        className="w-16 h-16 rounded-xl object-cover"
                    />
                </div>

                {/* Title */}
                <h3 className="font-semibold text-gray-900 text-center text-sm line-clamp-2 mb-2">
                    {title}
                </h3>

                {/* URL */}
                <p className="text-xs text-gray-500 text-center line-clamp-1 w-full">
                    {url}
                </p>

                {/* Delete Button (Edit Mode) */}
                {editMode && (
                    <button
                        onClick={deleteBookmark}
                        className="absolute top-2 right-2 w-8 h-8 bg-red-500 hover:bg-red-600 text-white rounded-lg flex items-center justify-center transition-colors shadow-md"
                    >
                        <XIcon size={16} />
                    </button>
                )}

                {/* Hover Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-br from-blue-500/0 to-purple-500/0 group-hover:from-blue-500/5 group-hover:to-purple-500/5 transition-all duration-300 rounded-2xl pointer-events-none"></div>
            </div>
        </a>
    );
}

export default Bookmark;
